export default "__VITE_ASSET__DXNvENed__"